import { TAB } from '../actions/types';
import createReducer from './createReducer';

/**
 * Every tab has a unique id different from the datasets id
 * this way we can have multiple instances of the same dataset
 * but different selections
 */

const reduceTabs = {
  [TAB.OPEN_SUCCEEDED]: (prevState, { dataset, tabId, sessionId, title }) => {
    const newTab = {
      [tabId]: { tabId, dataset, routePath: `/dataset/${tabId}`, sessionId, title, selections: { showJustTheMap: false } }
    };
    return Object.assign({}, prevState, newTab);
  },
  [TAB.CLOSE_SUCCEEDED]: (prevState, { tabId }) => ({ ...prevState, ...{ [tabId]: null } }),
  [TAB.UPDATE_VIEW_OPTION]: (prevState, { tabId, option }) => {
    const updateTab = {
      // TODO refactor and add viewOption into selections just like showJustTheMap
      [tabId]: { ...prevState[tabId], viewOption: option }
    }
    return Object.assign({}, prevState, updateTab);
  },
  [TAB.UPDATE_MAP_OPTION]: (prevState, { tabId, showJustTheMap }) => {
    const updateTab = {
      [tabId]: { ...prevState[tabId], ...{ selections: { ...prevState.selections, showJustTheMap }} }
    };
    return Object.assign({}, prevState, updateTab);
  },
  // more datasets reducers here UPDATE_MAP_OPTION
};

export default createReducer({}, reduceTabs);
